export const EXPECTED_CSV_COLUMNS = [
  'Start Date',
  'End Date',
  'Playdate Subject Name',
  'Space / Room',
  'Age Group',
  'Grade Group',
  'Time Slot',
  'Start time',
  'End time',
  'Capacity',
  'Teacher Name',
  'Teacher phone number',
  'Centre',
  'Price',
  'Price per session'
]

export const TIME_SLOTS = ['Morning', 'Afternoon', 'Evening']

export const EMPTY_MANUAL_ROW = {
  centre: null,
  course: null,
  room: null,
  teacher: null,
  startDate: '',
  endDate: '',
  startTime: '',
  endTime: '',
  timeSlot: '',
  ageGroup: '',
  gradeGroup: '',
  capacity: '',
  price: '',
  pricePerSession: ''
}

export const RESULT_STATUS_LABELS = {
  created: 'created',
  dry_run: 'dry-run',
  error: 'error',
  skipped: 'skipped'
}

// Convert a manual row (with object selections) to the flat CSV-shaped dict
// the backend expects (matches SUMMER_CAMP_CSV_COLUMNS).
export const manualRowToCsvRow = (row) => ({
  'start date': row.startDate || '',
  'end date': row.endDate || '',
  'playdate subject name': row.course?.name || '',
  'space / room': row.room?.name || '',
  'age group': row.ageGroup || '',
  'grade group': row.gradeGroup || '',
  'time slot': row.timeSlot || '',
  'start time': row.startTime || '',
  'end time': row.endTime || '',
  capacity: row.capacity === '' ? '' : String(row.capacity),
  'teacher name': row.teacher?.full_name || '',
  'teacher phone number': row.teacher?.phone_number || '',
  centre: row.centre?.name || '',
  price: row.price === '' ? '' : String(row.price),
  'price per session':
    row.pricePerSession === '' ? '' : String(row.pricePerSession)
})

// A manual row counts as "filled" if at least one required slot is set.
export const isManualRowFilled = (row) =>
  !!(
    row.centre ||
    row.course ||
    row.teacher ||
    row.room ||
    row.startDate ||
    row.endDate ||
    row.startTime ||
    row.endTime
  )
